import * as React from 'react';
import * as styled from './styled';
import {useFormikContext} from 'formik';
import {TaskObject} from 'api/task/types';
import Input from 'components/Input';
import ControlButton from 'components/ControlButton';
import {useBlockContext} from '../../../../../../hooks/useBlockContext';
import {IconTrash} from 'icons';
import {PairProps} from './types';

/**
 * The pair component of a accordance.
 * @param {PairProps} props
 * @return {React.ReactElement<PairProps>}
 * @constructor
 */
export default function Pair(
    props: PairProps,
): React.ReactElement<PairProps> {
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();
  const block = useBlockContext();

  // @ts-ignore
  const pairs = block?.pairs || [] as [string, string][];

  /**
   * Render fields.
   * @return {JSX.Element}
   */
  function renderFields(): JSX.Element {
    /**
     * Render field.
     * @return {JSX.Element}
     */
    function renderField(index: PairProps['index']): JSX.Element {
      /**
       * The change event handler.
       * @param {React.ChangeEvent<HTMLInputElement>} event
       */
      function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const updatedPair = props.pair;
        updatedPair[index] = event.target.value;
        setFieldValue(
          `content.blocks[${block.index}].pairs[${props.index}]`,
          updatedPair,
        );
      }

      return (
        <styled.Field>
          <Input
            value={props.pair[index]}
            placeholder="Введите текст"
            onChange={handleChange}
            required
          />
        </styled.Field>
      );
    }

    const LEFT_SIDE: number = 0;
    const RIGHT_SIDE: number = 1;

    return (
      <React.Fragment>
        {renderField(LEFT_SIDE)}
        {renderField(RIGHT_SIDE)}
      </React.Fragment>
    );
  }

  /**
   * Render controls.
   * @return {JSX.Element}
   */
  function renderControls(): JSX.Element {
    /**
     * Render delete.
     * @return {JSX.Element}
     */
    function renderDelete(): JSX.Element {
      /**
       * The click event handler.
       */
      function handleClick(): void {
        setFieldValue(
          `content.blocks[${block.index}].pairs`,
          pairs.filter((_: never, index: number) => (
            index !== props.index
          )),
        );
      }

      return (
        <ControlButton type="button" onClick={handleClick}>
          <IconTrash />
        </ControlButton>
      );
    }

    return (
      <styled.Controls>
        {renderDelete()}
      </styled.Controls>
    );
  }

  return (
    <styled.Wrapper>
      {renderFields()}
      {renderControls()}
    </styled.Wrapper>
  );
}
